export default __webpack_public_path__ + "static/zaklepschronisko-promo@3x-1f98cd51b8f4eb482a67eab8fa280fe0.webp";